import axios from 'axios'
import {Message} from 'element-ui'
import store from '@/store/index';
import evn from "../../util/evn";
import chatApi from '@/request/customer/customerRoom'
import {Decrypt} from '@/request/customer/util.js'
const { VUE_APP_IM_API, VUE_APP_APPID } = process.env

// create an axios instance
const service = axios.create({
  baseURL: VUE_APP_IM_API,
  timeout: 60 * 1000 // request timeout
})
const appid = VUE_APP_APPID

let kfRequests = []
let kfRefresh = false
let count = 0

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    config.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
    // if (!config.notToken) {
      // config.headers['Authorization'] = store.state.token
    // }
    config.headers['appid'] = appid
    config.headers['token'] = localStorage.getItem('cusetomerTokens') || ''
    config.headers['sid'] = localStorage.getItem('cusetomerSid') || ''
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    // if (res.code !== 1) {
    //   // Message({
    //   //   message: res.msg || res.message || '服务器异常',
    //   //   type: 'error',
    //   //   duration: 5 * 1000
    //   // })
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
    if(res.code == 1){
      return res
    } else if (res.code == -21004||res.code == -21003||res.code == -21002||res.code == -21005){
      if(!kfRefresh){
        count++
        if (count === 6) {
          return Promise.reject(res.data)
          // count= 0
        } else {
          kfRefresh = true
          return chatApi.getToken({
            format: "json",
            type: 2,
            userid: store.state.userData.telphone,
          }).then(res => {
            kfRefresh = false
            localStorage.setItem('cusetomerTokens', JSON.parse(Decrypt(res.msg)).token)
            Vue.prototype.$WSIM.createSocket()
            kfRequests.forEach(item => {
              item()
            })
            kfRequests = []
            return service(response.config)
          }).catch(() => {
            kfRefresh = false
          })
        }
      }else{
        // 返回未执行 resolve 的 Promise
        return new Promise(resolve => {
          // 用函数形式将 resolve 存入，等待刷新后再执行
          kfRequests.push(() => {
            resolve(service(response.config))
          })
        })
      }
    } else if (res.code == -22011){
      Vue.prototype.$WSIM.createSocket()
    } else {
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: '服务器异常',
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)


export default service
